import React from 'react';

const FormContainer = ({ 
  children, 
  className = '',
  maxWidth = 'max-w-md'
}) => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className={`w-full ${maxWidth} form-container transition-smooth ${className}`}>
        {children}
      </div>
    </div>
  );
};

export default FormContainer;